export const RECURRING_PAYABLE_STATUS = {
  NOT_APPLICABLE: '00000000-0000-0000-0000-000000000000',
  ACTIVE: 'b535cab2-8e3e-4f2d-8e93-0bf413ac1e47',
  PENDING: '7d02b6d9-7973-4d8d-bff2-30a0e80b55d3',
  EXPIRED: 'd7a816a0-303a-4a46-92f7-78b21e3effd3',
  CANCELLED: 'e1df0c3c-df31-47a3-a12d-d1bf2cf205b2',
  DRAFT: 'd5e24aeb-6a3f-4e9b-9a53-df9534716ae1'
};

export const EXPENSES_BATCH_TYPES = {
  ACH_WIRE: 'f99e8f1f-cc76-4b6b-9f8f-8015c764da3b',
  AP_TRACKING: '323c84e7-8e42-4de1-85d9-2a0271acbb7c',
  BILL_TO_EE_CHECK: 'b4a77a1c-5c30-4e0d-9f09-20531bd23a7b',
  BILL_TO_EE_INTL: 'f2574c4a-4b3e-4f8f-8a7a-7d8b81f4a5d0',
  BILL_TO_EE_ACH_WIRE: 'e2c9962f-f329-4413-9a5b-a307e265f7a0',
  BILL_TO_EE_TRACKING: '734b18a8-6e3a-4a7f-8c16-8a64e1c2b2b9',
  BLACKOUT: 'fdf8d0a5-f8f2-4e0d-8b2e-b3b2b7f8a3e0',
  CHECK: 'fd6b9f7f-ef87-4f42-8a20-8fda0b9d6d8a',
  CLIENT_INTEREST: 'f0c1b0c3-2c1e-4e4b-88d3-61e9d403f0b6',
  CODING_CORRECTION: '6b5d7d5e-81d7-4f29-b2b5-3f2a1c1b9d4e',
  DEPOSIT: 'a5c2e24f-5e38-47e9-9e1b-3a3a8140b3af',
  EM_TRACKING: 'f8fbc50e-4f02-4f1c-b08f-f0bf4d04312b',
  FEE: 'fd9f1c9e-52a6-4a12-9e9a-16a7c9b24f35',
  INTERNATIONAL: '0d73a4a7-3a6f-44a8-8f7e-5c5f1f22b07f',
  JOURNAL_ENTRY: '41d5b72f-55e1-4a8f-8ef9-1a2c1b5b02a5',
  ON_HOLD: '5cc1c52b-57d6-4c03-a19a-4e23f3a1e7d7'
};

export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

// authCommentRegarding.additionalField value marking a Regarding option that is offered under every comment service
export const AUTH_COMMENT_REGARDING_ALL_SERVICES_ID = '11111111-1111-1111-1111-111111111111';

export const VOUCHER_STATUS = {
  NOT_APPLICABLE: '8f5b6d3b-23a1-4dfc-bc3b-1b1bd24aeb78',
  DRAFT: '2a9d4d3e-d1a3-4a85-9f5a-5a6f0d7cb4b5',
  PENDING: 'ec1a2541-6f77-4a10-9b24-6c2a76a8ea0c',
  APPROVED: '2e7c4e78-bd32-4d1c-a54c-2e4f4c9b91da',
  DENIED: 'a6f9612f-870d-4b10-8a65-efb2f70a9a44'
};

export const LINE_ITEM_STATUS = {
  DRAFT: '00000000-0000-0000-0000-000000000000',
  DENIED: '79fe2e7c-6c1e-45d9-8d3b-600d4f82fbb3',
  PENDING: 'b15cf5f8-31bd-4a63-81d4-3c4f951a8686',
  PARTIAL_APPROVED: '6c1c39a0-f9d1-4a70-9d7e-b533b9d92966',
  APPROVED: '42f5a6d8-d62f-4f6a-9a6f-1a66f0e224d4'
};

export const EXPENSES_PAYEE_TYPE = {
  TRANSFEREE: 'c3b2c3c1-0324-4c7b-8b97-ef3f3a4a3f6e',
  VENDOR: '38c8b61e-2a18-4e3f-9c59-3a5e9b1a1d2a'
};

export const TRANSFEREE_FAMILY_MEMBER_TYPE_ID = '83FF7CBB-6EC5-4162-A449-9205B0E5C921';

// Task.TaskTriggerServiceGroup 'Letters': letter-sent task rules (catalog table Authorization.SentEmailTemplates)
export const TASK_TRIGGER_LETTERS_GROUP_ID = '531b89f3-9cd8-4471-b245-4d40a5dfd470';

// EnumerationV2.ComparisonOperator - compare with isIdEqual
export const COMPARISON_OPERATOR_IDS = {
  EQUALS: '6cdad80a-5606-49bd-9932-5613d6897b34',
  GREATER_THAN_OR_EQUAL: 'e359ce54-1ead-4983-8b38-42225c4573bd'
};

// EnumerationV2.TaskStatus - compare with isIdEqual
export const TASK_STATUS = {
  ACTIVE: '5640d88a-9546-45e2-b9f2-4aa81b178ee6',
  OVERDUE: '3aed3b2c-6918-41e4-bddf-65b2b08f18d2', // Overdue is inactive, but kept for historical records
  CANCELED: '59dad24a-41a2-4f69-849d-b3e099597dd2',
  COMPLETED: '28125dac-5d57-4bb4-a92e-e411415fd8c3',
  OPEN: '9784d0a0-255c-4a83-8e58-793484264b4d',
  WAITING_FOR_EE: 'fbcfe39a-be0e-489e-bea0-d7da985ff581',
  WAITING_FOR_VENDOR: '0900c915-4a22-48ca-8f2d-2f1a6726d67a'
};

// Compare these with isIdEqual - the API is not consistent about GUID casing.
export const RENTAL_CAR_CLASS_IDS = {
  NONE: ZERO_GUID,
  ECONOMY: '272a9c7d-be97-4e3c-8dec-44cb47e6c93a',
  COMPACT_SEDAN: '348548bb-29f3-446a-a27d-6285cc3225a7',
  MIDSIZE_SEDAN: '0754acc7-568b-488e-9f6e-875ddda52600',
  FULL_SIZE_SEDAN: 'ff6b37a6-7a44-43e2-9e41-6c8ab015f168',
  COMPACT_SUV: '91dec9b9-f3ac-4666-96e3-ccfb22b10362',
  FULL_SIZE_SUV: '633da65e-76f3-4046-b7d8-97470714db99',
  OTHER: '1bb6fddf-24a9-4c6c-8569-60fdf5613b76'
};

export const EXPENSE_STATUSES = {
  NOT_VIEWED: '6f3b939e-1f43-4a8b-a103-dbb3f1d3f4f9',
  ON_HOLD: '4ae21fb8-0b9b-4d9a-9b41-0f96e2680d9a',
  VIEWED: '4b9b6e2a-3ab0-44a9-8e54-8ea0db4a3518'
};

export const CANDIDATE_SERVICE_STATUSES = {
  NONE: '00000000-0000-0000-0000-000000000000',
  INITIATED: '4977115d-e1f3-4022-95dc-4ab16e401c0d',
  TRIP_COORDINATION: '9da99030-30bf-4e13-91f9-2eb7305ef302',
  EXPENSE_PROCESSING: 'b88cfc9e-ca44-43b3-8471-a7f7c3d6a84c',
  CLOSED: 'd9f99d09-dcda-448c-80fd-44402353d34b',
  CANCELED: '680eb1e7-9f69-4b68-933d-beedaa4bc38c',
  ACTIVE_INTERNSHIP: '2e3ffb8e-6382-4f94-bb4e-694a8c5386a2'
};

export const AUTHORIZATION_MOVE_TYPES = {
  INTERSHIP: '4DC01913-217D-44BD-8E4E-82C8B82F6DE4'
};

export const TEMPORARY_LIVING_STATUSES = {
  INITIATED: '6899138E-523E-4A30-ACE3-65713B1A3487',
  REQUESTED: '85645814-F990-4E7B-B1F0-017404C04D42',
  OPTIONS_SENT: '77C39648-D167-4D71-8DAE-5CDD43F5F6B4',
  CONFIRMED: '89065C04-C5AF-4E77-8735-888C58FB52F4',
  MOVED_IN: '5FF26A8E-D662-447C-AC64-9A4F93511DA6',
  NOTICE_TO_VACATE_SENT: 'B81523D3-07BF-4778-81A5-330CB02AF041',
  MOVED_OUT: '62BD5585-6009-4811-A783-8656393FA240',
  CANCELED: '3A5A88B9-C037-4B0D-82BB-EA3833F3AF04'
};

export const HHG_STATUS = {
  none: '00000000-0000-0000-0000-000000000000',
  initiated: '7E7D1F13-0B12-4C0F-9F7C-6A5C9FC4B0C1',
  ordered: '2A7BCF4E-5F1E-4D2C-9C3B-4B3C6E2B7F11',
  survey: '6C2E8B67-6D5A-4D1B-8B3F-9C6A2A1B5E44',
  received: '9DA99030-30BF-4E13-91F9-2EB7305EF302',
  estimateAccepted: 'A5E8C2F3-4B7D-4E9A-8F2C-3D6A5B1E7F44',
  inTransit: 'B88CFC9E-CA44-43B3-8471-A7F7C3D6A84C',
  delivered: 'D9F99D09-DCDA-448C-80FD-44402353D34B',
  completed: '680EB1E7-9F69-4B68-933D-BEEDAA4BC38C',
  onHold: '4977115D-E1F3-4022-95DC-4AB16E401C0D',
  canceled: '2E3FFB8E-6382-4F94-BB4E-694A8C5386A2'
};

export const GLOBAL_STATUSES = {
  NONE: '00000000-0000-0000-0000-000000000000',
  INITIATED: '34DA890F-7CCC-443C-8958-A7294BA1D19D',
  ON_ASSIGNMENT: '93A764E7-8DEF-4F98-8A6A-B2F9C6C28C27',
  EXTENDED: 'BFF5CBD2-A37E-4DFF-B188-D6AE23AF3C0D',
  ASSIGNMENT_ENDED: '5A2C06D1-E44C-45D7-9B80-881B637F1BA4',
  REPATRIATED: 'CA264EA6-4E79-4F6E-A8B2-0F7D309C76F3',
  ON_HOLD: '7C70F26C-E2E9-47B4-919F-2D5F3C5BFE79',
  COMPLETED: 'D355DD35-45D0-4619-AD94-7DF42B67E8A7',
  CANCELED: 'B85731E7-7940-4352-8FE3-11B7FA44D97A'
};

export const LINE_ITEM_TYPES = {
  VOUCHER: '6d7d4b92-9b2e-49f0-9e2b-1b1e7c4a4095'
};

export const SERVICE_IDS = {
  TEMP_LIVING_SERVICE_ID: 'c8aabef5-9434-4e8e-8a6b-4417747ecbed',
  HHG_SERVICE_ID: 'e8d4399d-b059-4fcb-9959-fc64c4bb25f3',
  GLOBAL_SERVICE_ID: '7d4d3d04-66b8-4d44-9131-5c7b2cf8b1f6',
  DESTINATION_RENTER_SERVICE_ID: '946f7f77-2a35-4d86-9b18-616f927f7124',
  HOME_SALE_SERVICE_ID: 'f81b6b37-52b0-4903-9203-6fd184192054',
  DESTINATION_BUYER_SERVICE_ID: '946f7f77-2a35-4d86-9b18-616f927f7124',
  CANDIDATE_SERVICE_ID: 'a2ac4e46-bfd3-4656-8f52-e8d0d2aef2dc',
  INTERN_SERVICE_ID: 'a2ac4e46-bfd3-4656-8f52-e8d0d2aef2dc'
};

export const TEMPLATE_USER_TYPES_IDS = {
  TRANSFEREE: 'c3b2c3c1-0324-4c7b-8b97-ef3f3a4a3f6e',
  VENDOR: '38c8b61e-2a18-4e3f-9c59-3a5e9b1a1d2a'
};

export const EMAIL_TEMPLATE_STATUS_IDS = {
  DRAFT: 'A209B5C7-9AC6-4D79-8544-5721817A5EA6',
  ACTIVE: '5F4FF376-A3E5-4767-87FC-BD42B8EF0AD1',
  EXPIRED: '5EC6BBBB-36BE-4C95-BD0F-E8ED1E083EDB',
  CANCELLED: '435010EF-52CB-489D-8799-63AE81B6DE68'
};

export const API_REQUEST_TYPES_IDS = {
  MORREALE: 'B2966815-6493-4FE9-ADA6-C40C0EB45DE5'
};

export const AUTHORIZATION_FILE_STATUS_IDS = {
  ACTIVE: '9A5B2115-645C-479C-93A4-19A5CC4BB8B2',
  CANCELLED: '9F60F1D5-7262-4EF3-ADB2-FB44EED451A1',
  CLOSED: 'F747DF40-F464-4DAF-BA75-5EC8EF67E64F',
  INIT: '714957FD-0EC1-42A1-BE26-FCBA81CA0795',
  ON_ASSIGNMENT: 'C60BAD4D-85CF-4A9E-8F5E-C0299FD09CFD',
  ON_HOLD: 'A9F7B1E1-1335-48F6-B7B3-2D90669A528D',
  OPS_CLOSED: 'C638A88A-B3E4-4BB5-A7F5-C5CD88082E1E',
  PENDING: 'A41F3EC8-AE90-4A2E-A8E1-73156AAFC32A',
  NONE: '00000000-0000-0000-0000-000000000000'
};

export const BANK_PAYMENT_TYPES = {
  ACH: 'A7F3E8B1-2D4C-4E9A-8F6B-1C5D7A9E2B3F',
  INTERNATIONAL_WIRE: 'B8E4F9C2-3E5D-4F0B-9A7C-2D6E8B0F3C4A',
  WIRE: 'C9F5A0D3-4F6E-5A1C-0B8D-3E7F9C1A4D5B',
  CASH_PAYMENT: 'D0A6B1E4-5A7F-6B2D-1C9E-4F8A0D2B5E6C',
  CHECK_PAYMENT: 'E1B7C2F5-6B8A-7C3E-2D0F-5A9B1E3C6F7D'
};
